export default __webpack_public_path__ + "static/media/grid-frame.52a156ec.svg";